// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e59237fc","667":"f5c811a4","977":"5d7fa649"}[chunkId] + ".chunk.js";
};